import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 16px;
  background: #ffd3cc;
  border-radius: 4px;
  white-space: pre-wrap;

  svg {
    margin-top: 3px;
    flex-shrink: 0;

    &.fa-circle-exclamation {
      color: #ff4d4f;
    }
  }

  &.correction-blocked-reason {
    margin-bottom: 16px;
  }
`

export const Message = styled.span`
  flex: 1;
`

export const Link = styled.a`
  color: #3b7de9;
  white-space: nowrap;
`
